<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="linkTo('/craftsman/edit')"
            >添加手艺人</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="artisansList" style="width: 100%">
            <el-table-column label="姓名" prop="nickName"> </el-table-column>
            <el-table-column label="手机号" prop="phoneNum"> </el-table-column>
            <el-table-column label="排序" align="center">
              <template slot-scope="scope">
                <el-input
                  class="indexno-input"
                  v-if="scope.row.isChangeIndexNo"
                  placeholder="0-50"
                  type="number"
                  v-model="indexNo"
                  size="small"
                  :ref="`indexnoinput${scope.$index}`"
                  @blur="changeIndexNo($event, scope.$index)"
                  @keydown.enter="changeIndexNo($event, scope.$index)"
                ></el-input>
                <div v-else @click="showChangeIndexNo(scope.$index)">
                  {{ scope.row.indexNo }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="网店展示" align="center">
              <template slot-scope="scope">
                <el-select
                  class="showinonline-select"
                  v-if="scope.row.isChangeShowInOnline"
                  v-model="isShowInOnlineStore"
                  placeholder="请选择"
                  size="small"
                  @change="changeShowInOnline($event, scope.$index)"
                >
                  <el-option
                    v-for="item in showInOnlineOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div v-else @click="showChangeShowInOnline(scope.$index)">
                  {{ scope.row.isShowInOnlineStore == 2 ? "否" : "是" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="关联服务" align="center">
              <template slot-scope="scope">
                <div>
                  {{ bindStatusObj[scope.row.bindStatus] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button
                    size="small"
                    type="primary"
                    @click="editService(scope.$index)"
                    >关联服务</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="linkTo(`/craftsman/edit?workUserId=${scope.row.workUserId}`)"
                    plain
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    @click="deleteCraftsman(scope.row)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div
      class="popup"
      v-if="showEditServicePop"
      :class="{
        show: showEditServicePop,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>关联服务</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="showEditServicePop = false"
          />
        </div>
        <div class="popup-container center">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
          <el-tree
            class="filter-tree"
            :current-node-key="currentServiceList"
            show-checkbox
            node-key="value"
            :data="serviceList"
            :props="defaultProps"
            default-expand-all
            highlight-current
            :filter-node-method="filterNode"
            ref="tree"
          >
          </el-tree>
          <el-button type="primary" @click="confirmService">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEdcShopGoodsCategorys,
  getFindAllGoodsPlus,
  bindService,
  artisansInfo,
  findArtisansCount,
  findArtisans,
  saveOrUpdateArtisans,
  delArtisans,
} from "@/api/index.js";
import request from "@/utils/request";
let pageLoading = null;
export default {
  data() {
    return {
      workUserId: "",
      artisansList: [],
      indexNo: "",
      bindStatusObj: {
        0: "无关联",
        1: "部分关联",
        2: "全部关联",
      },
      showEditServicePop: false,
      isShowInOnlineStore: 1,
      showInOnlineOptions: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 2,
          label: "否",
        },
      ],
      classifyList: [
        {
          value: "0",
          label: "全选",
          children: [],
        },
      ],
      filterText: "",
      serviceList: [
        {
          value: "0",
          label: "全选",
          type: "all",
          children: [],
        },
      ],
      mapserviceList: {},
      currentServiceList: "",
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  components: {},
  mounted() {
    this.getPageData();
  },
  watch: {
    currentServiceList(val) {
      console.log(val);
    },
    showEditServicePop(val) {
      this.filterText = "";
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    deleteCraftsman(row) {
      this.$confirm("此操作将永久删除该艺人, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(({ value }) => {
        delArtisans({
          workUserId: row.workUserId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "删除成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 3000,
            });
          }
        });
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        categoryNatureType: 2,
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          let list = [];
          res.data.forEach((val, index) => {
            list[index] = {};
            list[index].value = val.goodsCategoryId;
            list[index].label = val.categoryName;
            list[index].type = "goodsCategor";
          });
          this.classifyList[0].children = JSON.parse(JSON.stringify(list));
          this.serviceList[0].children = JSON.parse(JSON.stringify(list));
          this.serviceList[0].children.forEach((val, index) => {
            this.getserviceList(val.value, index);
          });
        } else {
          pageLoading.close();
        }
      });
    },
    getserviceList(goodsCategoryId, index) {
      getFindAllGoodsPlus({
        goodsNatureType: 2,
        goodsCategoryId,
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        this.serviceList[0].children[index].children = [];
        if (res.code == 1) {
          res.data.forEach((val, ind) => {
            if (!val.products.length) {
              this.serviceList[0].children[index].children.push({
                label: val.goodsName,
                value: String(val.goodsId),
                goodsId: val.goodsId,
                type: "service",
              });
            }
            if (val.products.length) {
              this.serviceList[0].children[index].children.push({
                label: val.goodsName,
                value: String(val.goodsId),
                goodsId: val.goodsId,
                type: "product",
                children: [],
              });
              val.products.forEach((product) => {
                this.serviceList[0].children[index].children[ind].children.push({
                  label: `${val.goodsName}(${product.valueContent})`,
                  value: String(val.goodsId) + String(product.productId),
                  goodsId: val.goodsId,
                  productId: product.productId,
                  type: "service",
                });
              });
            }
            this.mapserviceList[val.goodsId] = {
              goodsCategoryId: goodsCategoryId,
              goodsId: val.goodsId,
            };
          });
        }
        if (res.code == -1) {
          // this.serviceList = [];
        }
        if (index == this.serviceList[0].children.length - 1) {
          setTimeout(() => {
            this.serviceList = this.serviceList[0].children.filter((val) => {
              console.log(22, val);
              return val.children && val.children.length > 0;
            });
            pageLoading.close();
          }, 500);
        }
        console.log(this.serviceList);
      });
    },
    getPageData() {
      pageLoading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        pageLoading.close();
      }, 60e3);
      this.findArtisans();
      this.getEdcShopGoodsCategorys();
    },
    findArtisans() {
      findArtisans({
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.isChangeIndexNo = false;
            val.isChangeShowInOnline = false;
          });
          this.artisansList = res.data;
        }
        if (res.code == -1) {
          this.artisansList = [];
        }
      });
    },
    saveOrUpdateArtisans(params) {
      saveOrUpdateArtisans(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.findArtisans();
        }
      });
    },
    showChangeShowInOnline(index) {
      this.artisansList.forEach((val) => {
        val.isChangeShowInOnline = false;
      });
      this.isShowInOnlineStore = this.artisansList[index].isShowInOnlineStore;
      this.artisansList[index].isChangeShowInOnline = true;
    },
    showChangeIndexNo(index) {
      this.artisansList[index].isChangeIndexNo = true;
      this.$nextTick(() => {
        this.$refs[`indexnoinput${index}`].focus();
      });
    },
    changeIndexNo(e, index) {
      console.log(e, index);
      if (!this.indexNo) {
        this.artisansList[index].isChangeIndexNo = false;
        return;
      }
      this.artisansList[index].indexNo = this.indexNo || 0;
      this.artisansList[index].isChangeIndexNo = false;
      this.saveOrUpdateArtisans(this.artisansList[index]);
      this.indexNo = "";
    },
    changeShowInOnline(e, index) {
      console.log(e, index);
      this.artisansList[index].isShowInOnlineStore = this.isShowInOnlineStore || 1;
      this.artisansList[index].isChangeShowInOnline = false;
      this.saveOrUpdateArtisans(this.artisansList[index]);
    },
    editService(index) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 60e3);
      this.workUserId = this.artisansList[index].workUserId;
      artisansInfo({
        workUserId: this.workUserId,
      }).then((res) => {
        if (res.code == 1) {
          let list = [];
          res.data.servicesList.forEach((val) => {
            if (val.productId) {
              list.push(String(val.goodsId) + String(val.productId));
            } else {
              list.push(val.goodsId);
            }
          });
          loading.close();
          this.showEditServicePop = true;
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(list);
          });
        }
      });
    },
    confirmService() {
      let list = [];
      this.$refs.tree.getCheckedNodes().forEach((val) => {
        if (val.type == "service") {
          if (val.productId) {
            list.push({
              goodsId: val.goodsId,
              productId: val.productId,
            });
          } else {
            list.push({
              goodsId: val.goodsId,
            });
          }
        }
      });
      bindService({
        workUserId: this.workUserId,
        servicesStr: JSON.stringify(list),
      }).then((res) => {
        this.showEditServicePop = false;
        this.findArtisans();
      });
      console.log(this.$refs.tree.getCheckedNodes());
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .el-cascader {
    width: 100%;
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
.el-input + .el-input {
  margin-top: 10px;
}
.xls-row {
  display: flex;
}
.indexno-input,
.showinonline-select {
  width: 100px;
}
.popup-content {
  width: 600px;
  padding: 10px;
  .popup-container {
    margin: 10px 0;
    text-align: center;
    .filter-tree {
      height: 500px;
      margin: 10px 0;
      overflow: auto;
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #ffffff;
      }
      &::-webkit-scrollbar {
        display: block;
        width: 10px;
        height: 10px;
        background-color: #f5f5f5;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.3);
        background-color: #eeeeee;
      }
    }
  }
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
